import React, { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { UPDATE_EVENT_MUTATION } from "./sections.queries";
import { ISectionsProps } from "./ISections";
import { formatTime } from "../../utils/time";
import GridSections from "./GridSections/GridSections";
import useNavigateToMultipleEdit from "@dimensions/section/hooks/useNavigateToMultipleEdit";
import GridSectionsSkeleton from "./GridSections/grid-sections-skeleton";
import { useGetHolidays } from "@services/collections/holidays/holidaysServices";
import { useParams } from "react-router-dom";

const Sections: React.FC<ISectionsProps> = (props: ISectionsProps) => {
  const { scenario }: any = useParams();
  const [{ holidays, isLoaded }, getHolidays] = useGetHolidays({ scenario });
  const [updateEvents] = useMutation(UPDATE_EVENT_MUTATION, {});
  const startBlock = localStorage.getItem("range-start-time");
  const endBlock = localStorage.getItem("range-end-time");
  const blockRanges = formatTime(startBlock, endBlock);
  const callUpdateHook = (variables: any, callback: (value: any) => void) => {
    updateEvents({ variables })
      .then(data => callback({ status: "OK", content: data }))
      .catch(err => callback({ status: "ERROR", content: err }));
  };

  const { handleNavigateToMultipleEdit } = useNavigateToMultipleEdit();

  useEffect(() => {
    if (!isLoaded) {
      getHolidays();
    }
  }, []);

  if (props?.isLoading || !isLoaded) {
    return <GridSectionsSkeleton />;
  }

  return (
    <div className="container-fluid" style={{ padding: "0px !important" }}>
      <div className="row">
        <GridSections
          {...props}
          holidays={holidays}
          onOpenEdit={handleNavigateToMultipleEdit}
          calendarRanges={blockRanges}
          updateEvent={(variables: any, callback: (value: any) => void) =>
            callUpdateHook(variables, callback)
          }
        />
      </div>
    </div>
  );
};

export default Sections;
